import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=2131a5ef&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2131a5ef')) {
      api.createRecord('2131a5ef', component.options)
    } else {
      api.reload('2131a5ef', component.options)
    }
    module.hot.accept("./Dashboard.vue?vue&type=template&id=2131a5ef&", function () {
      api.rerender('2131a5ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Dashboard/Dashboard.vue"
export default component.exports